import { Box } from '@palmetto/palmetto-components';

import { AccountRequirementStatus, SalesRepStatus, salesRepStatusLabels } from 'types';

import EventBy from './EventBy';

const SalesRepVerified = ({ event }: { event: any }) => {
  const salesRepName = event?.data?.salesRepName as string | undefined;
  const salesRepStatus = event?.data?.salesRepStatus as SalesRepStatus | undefined;
  const requirementStatus = event?.data?.requirementStatus as AccountRequirementStatus | undefined;
  const recheckId = event?.data?.recheckId as string | undefined;
  const requirementOutcomeLabel =
    requirementStatus === AccountRequirementStatus.completed
      ? 'Completed'
      : requirementStatus === AccountRequirementStatus.rejected
        ? 'Rejected'
        : null;

  return (
    <Box direction="column" childGap="2xs">
      <Box direction="row" alignItems="center" childGap="xs" flex="auto">
        <EventBy event={event} />
        <Box as="span" color="body-secondary">
          &nbsp;— Sales Rep {salesRepName ? <strong>{salesRepName}</strong> : null}
          {recheckId ? ` (ID:${recheckId})` : ''} verified identity
        </Box>
      </Box>
      {salesRepStatus ? (
        <Box as="span" color="body-secondary" fontSize="xs">
          Rep status at verification: <strong>{salesRepStatusLabels[salesRepStatus] ?? salesRepStatus}</strong>
          {requirementOutcomeLabel ? (
            <>
              {' • '}Requirement marked: <strong>{requirementOutcomeLabel}</strong>
            </>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default SalesRepVerified;
